/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { ref, watch, nextTick, onMounted } from 'vue';

function useInputWidth(props, inputPreRef, inputRef, innerValue) {
  var composing = ref(false);

  var updateInputWidth = function updateInputWidth() {
    if (!inputPreRef.value) return;
    var width = inputPreRef.value.offsetWidth;
    if (width === 0) return;
    inputRef.value.style.width = "".concat(width, "px");
  };

  var addListeners = function addListeners() {
    watch(function () {
      return innerValue.value + props.placeholder;
    }, function () {
      if (!props.autoWidth) return;
      nextTick(function () {
        updateInputWidth();
      });
    }, {
      immediate: true
    });
  };

  onMounted(function () {
    composing.value = false;

    if (props.autoWidth) {
      addListeners();
    }
  });
}

export { useInputWidth as default };
//# sourceMappingURL=useInputWidth.mjs.map
